import {NavigateFunction} from "react-router-dom";
import {getUserTokenOrRedirect} from "../../shared/services/auth.service";
import {AddEstimateCostItemDto, EstimateCostItemDto, UpdateEstimateCostItemDto} from "../../shared/dtos/estimate-cost-item.dto";

export async function getCostItems(navigate: NavigateFunction, estimateId: number): Promise<EstimateCostItemDto[]> {
  const token = await getUserTokenOrRedirect(navigate)
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/estimates/${estimateId}/cost-items`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(async r => r.ok ? (await r.json()) as EstimateCostItemDto[] : Promise.reject(r));
}

export async function createCostItem(navigate: NavigateFunction, estimateId: number, costItem: AddEstimateCostItemDto): Promise<EstimateCostItemDto> {
  const token = await getUserTokenOrRedirect(navigate)
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/estimates/${estimateId}/cost-items`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(costItem),
    }).then(async r => r.ok ? (await r.json()) as EstimateCostItemDto : Promise.reject(r));
}

export async function updateCostItem(navigate: NavigateFunction, estimateId: number, costItemId: number, costItem: UpdateEstimateCostItemDto): Promise<EstimateCostItemDto> {
  const token = await getUserTokenOrRedirect(navigate)
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/estimates/${estimateId}/cost-items/${costItemId}`,
    {
      method: 'PATCH',
      body: JSON.stringify(costItem),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }).then(async r => r.ok ? (await r.json()) as EstimateCostItemDto : Promise.reject(r));
}

export async function deleteCostItem(navigate: NavigateFunction, estimateId: number, costItemId: number) {
  const token = await getUserTokenOrRedirect(navigate)
  const response = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/estimates/${estimateId}/cost-items/${costItemId}`,
    {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

  if (!response.ok) {
    throw new Error(`Failed to delete cost item: ${response.statusText}`);
  }
}
